import React, { useEffect, useRef } from "react";
import {
  VideoContainer,
  VideoContent,
} from "../styles/components/Galleries/Video";

const Video = ({ videoId, wrap }) => {
  const wrapperRef = useRef(null);
  const hideControls = true;
  const aspectRatio = "9:16";
  const playerRef = useRef(null);

  const videoOptions = {
    controls: ["play", "progress", "mute", "volume"],
    autoplay: true,
    autopause: false,
    muted: true,
    loop: { active: true },
    hideControls: true,
    ratio: aspectRatio,
    playsinline: true,
  };

  useEffect(() => {
    if (wrapperRef.current) {
      const Plyr = require("plyr");
      require("plyr/dist/plyr.css");
      playerRef.current = new Plyr(wrapperRef.current, {
        ...videoOptions,
      });
    }
    return () => {
      if (playerRef.current) {
        playerRef.current.destroy();
      }
    };
  }, []);

  return (
    <VideoContainer $wrap={wrap}>
      <VideoContent $aspectRatio={aspectRatio} $hideControls={hideControls}>
        <div
          ref={wrapperRef}
          data-plyr-provider="vimeo"
          data-plyr-embed-id={videoId}
          muted
        ></div>
      </VideoContent>
    </VideoContainer>
  );
};

export default Video;
